import { render } from "./JbButton.vue?vue&type=template&id=449bc91a"
import script from "./JbButton.vue?vue&type=script&lang=js"
export * from "./JbButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__